/**
 * Styled components for knowledge base module (super-admin).
 * Follows the same approach as News and Events modules.
 */

import styled from '@emotion/styled';
import { Card, Space, Typography, Row } from 'antd';

export const PageWrapper = styled.div`
  padding: 10px 0;
`;

export const LoadingContainer = styled.div`
  text-align: center;
  padding: 48px;
`;

export const PageTitle = styled.h2`
  margin-bottom: 24px;
`;

export const PageSubtitle = styled(Typography.Paragraph)`
  margin-bottom: 24px !important;
`;

export const HeaderRow = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FormHeaderRow = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SectionTitle = styled.h2`
  margin: 0;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FlexColumnGap24 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FlexWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CardWithMargin = styled(Card)`
  margin-bottom: 24px;
`;

export const VerticalSpace = styled(Space)`
  width: 100%;
`;

export const SortableRow = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 6px;
  margin: 4px 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SortableRowDrag = styled.div`
  cursor: grab;
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
`;

export const SortableRowBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SortableRowTitle = styled(Typography.Text)`
  font-size: 16px;
`;

export const SortableRowMeta = styled.div`
  margin-top: 4px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const DragHandlePlaceholder = styled.div`
  width: 24px;
`;

export const ScrollContainer = styled.div`
  max-height: 600px;
  overflow-y: auto;
`;

export const ArticlesScrollContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
`;

export const FilterRow = styled(Row)`
  margin-bottom: 24px;
`;
